let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
import waitForElm from '../util/util_wait_for_element'
import computeTourSteps from '../core/steps'
/**
 * handleTourStart
 * @param group : string
 */
function handleTourStart(group) {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        if (this.isVisible) {
          if (this.options.debug) console.warn('Tour already active')
          return reject('Tour already active')
        }
        if (group) this.group = group
        if (this.options.debug) console.info('Start tour')
        const tgInstance = this
        /**
         * Tour steps
         */
        try {
          // Compute steps
          yield computeTourSteps(tgInstance)
        } catch (e) {
          if (this.options.debug) console.warn(e)
          return reject(e)
        }
        /**
         * Go to step
         */
        yield tgInstance.visitStep(this.activeStep).catch(e => {
          if (this.options.debug) console.warn(e)
          return reject(e)
        })
        /**
         * Ensure dialog is rendered in DOM
         */
        yield waitForElm('.tg-dialog').then(() =>
          __awaiter(this, void 0, void 0, function*() {
            /**
             * Init listeners
             * Double initialization is handled inside of handler
             */
            yield this.initListeners()
            // Add transition class to dialog after additional delay to prevent flying in from random position
            if (this.options.dialogAnimate)
              this.dialog.classList.add('animate-position')
            // setTimeout(()=>{
            // }, 100)
          })
        )
        return resolve(true)
      })
    )
  })
}
export default handleTourStart
